module.exports = __webpack_public_path__ + "img/GB.04a77a81.svg";